import { VIOLET, WHITE } from '../checklistColors'

export const getProgressBarColor = (isCaughtUp) => {
  if (isCaughtUp) {
    return VIOLET
  }
  return WHITE
}
